export default __webpack_public_path__ + "static/media/mutate-alex-2.ec016842.png";